// packages
import { Component } from "react";

// views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";

// Styles
import "./superAdmin.css";

//assets
import websitedetails from "../../assets/images/websitedetails.png";
import landingpage from "../../assets/images/landingpage.png";
import guidelines from "../../assets/images/guidelines.png";
import highlights from "../../assets/images/highlights.png";
import pricing from "../../assets/images/pricing.png";
import blogimg from "../../assets/images/blogimg.png";
import contactus from "../../assets/images/contactus.png";

import { Link } from "react-router-dom";
import SuccessDialog from "../schoolAdminPortal/Popups/SuccessDialog";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

class Website extends Component {
  constructor() {
    super();
    this.state = {
      successPopup: false,
      msg: "We are working on this feature",
      loginRole: getFromLocalStorage("loginRole"),
    };
  }
  componentDidMount() {
    const acticve = document.getElementById("Website");
    if (acticve) {
      acticve.classList.add("active");
    }
  }
  toggleSuccessDialog = (status) => {
    this.setState({ successPopup: status });
  };
  render() {
    const { successPopup, msg, loginRole } = this.state;
    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div className="">
            <SuperAdminDashboard />
            <div className="content-layout">
              <label className="fs-24 bold black pt-3 pl-4 pb-0">
                MANAGE WEBSITE
              </label>
              <div className="row px-3">
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="">
                    <Link className="websiteBox " to="/WebsiteDetails">
                      <img
                        src={websitedetails}
                        alt="web"
                        className="webimgstyle"
                      />
                      <div className="clear20" />
                      <p className="fs-20 semibold cp website-link">
                        WEBSITE DETAILS
                      </p>
                    </Link>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="">
                    <Link className="websiteBox cp" to="/landingpagedetails">
                      <img
                        src={landingpage}
                        alt="web"
                        className="webimgstyle"
                      />
                      <div className="clear20" />
                      <p className="fs-20 semibold website-link">
                        LANDING PAGE
                      </p>
                    </Link>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="">
                    <Link className="websiteBox cp" to="/guidelinedetails">
                      <img src={guidelines} alt="web" className="webimgstyle" />
                      <div className="clear20" />
                      <p className="fs-20 semibold website-link">GUIDELINES</p>
                    </Link>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="">
                    <Link className="websiteBox cp" to="/highlightsdetails">
                      <img src={highlights} alt="web" className="webimgstyle" />
                      <div className="clear20" />
                      <p className="fs-20 semibold website-link">HIGHLIGHTS</p>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row px-3">
                <div className="col-12 col-md-6 col-lg-3">
                  <div
                    className="websiteBox cp"
                    onClick={() => this.toggleSuccessDialog(true)}
                  >
                    <img src={pricing} alt="web" className="webimgstyle" />
                    <div className="clear20" />
                    <p className="fs-20 semibold website-link">PRICING</p>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div
                    className="websiteBox cp"
                    onClick={() => this.toggleSuccessDialog(true)}
                  >
                    <img src={blogimg} alt="web" className="webimgstyle" />
                    <div className="clear20" />
                    <p className="fs-20 semibold website-link">BLOG</p>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="">
                    <Link className="websiteBox cp" to="/contactusdetails">
                      <img src={contactus} alt="web" className="webimgstyle" />
                      <div className="clear20" />
                      <p className="fs-20 semibold website-link">CONTACT US</p>
                    </Link>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                  <div className="">
                    <Link className="websiteBox " to="/managevideostreaming">
                      <img
                        src={websitedetails}
                        alt="web"
                        className="webimgstyle"
                      />
                      <div className="clear20" />
                      <p className="fs-20 semibold cp website-link">
                        Video Streaming
                      </p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <SuccessDialog
              successPopUp={successPopup}
              msg={msg}
              toggleSuccessDialog={this.toggleSuccessDialog}
            />
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}
export default Website;
